/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_1Inputs */

const en_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Featured`)
};

const es_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Destacado`)
};

const fr_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ En vedette`)
};

const de_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Hervorgehoben`)
};

const ja_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ おすすめ`)
};

const zh_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ 特别推荐`)
};

const ar_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ مميز`)
};

const id_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Unggulan`)
};

const it_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ In Evidenza`)
};

const ru_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ В центре внимания`)
};

const pt_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Destaque`)
};

const ko_featured_1 = /** @type {(inputs: Featured_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ 추천`)
};

/**
* | output |
* | --- |
* | "✦ Featured" |
*
* @param {Featured_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const featured_1 = /** @type {((inputs?: Featured_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_1(inputs)
	if (locale === "es") return es_featured_1(inputs)
	if (locale === "fr") return fr_featured_1(inputs)
	if (locale === "de") return de_featured_1(inputs)
	if (locale === "ja") return ja_featured_1(inputs)
	if (locale === "zh") return zh_featured_1(inputs)
	if (locale === "ar") return ar_featured_1(inputs)
	if (locale === "id") return id_featured_1(inputs)
	if (locale === "it") return it_featured_1(inputs)
	if (locale === "ru") return ru_featured_1(inputs)
	if (locale === "pt") return pt_featured_1(inputs)
	return ko_featured_1(inputs)
});